import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Organization } from '../types/organization';
import { LogService } from './log.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  organizations: Organization[];

  constructor(private log: LogService, private http: HttpClient) {}

  getOrganizations(): Organization[] {
    return this.organizations;
  }

  fetchData(): Observable<Organization[]> {
    if (!this.organizations) {
      this.log.trace(
        'fetching organizations from ' + environment.api.organizationList
      );
      const result = this.http.get<Organization[]>(
        environment.api.organizationList
      );
      result.subscribe(data => {
        this.organizations = _.sortBy(data, 'display');
        this.log.trace('organization data loaded', this.organizations);
      });
      return result;
    } else {
      this.log.trace(
        'organizations data already loaded, skipping fetch',
        this.organizations
      );
      return of(this.organizations);
    }
  }
}
